import { Routes as ReactRouterRoutes } from "react-router-dom";
import { withSentryReactRouterV6Routing } from "@sentry/react";

/**
 * This is a wrapper around the react-router-dom Routes component that adds Sentry's routing integration.
 *
 * This is useful for monitoring the performance of your application and tracking errors that occur during navigation,
 * it allows Sentry to track route changes and performance metrics.
 */
export const Routes = withSentryReactRouterV6Routing(ReactRouterRoutes);
